'use client';

import React from 'react';
import SectionBase from '@/components/ui/sections/section-base';
import SectionHeader from '@/components/ui/sections/section-header';

const SECTION_ID = 'service-area-hero';

interface HeroProperties {
  title: string;
  description: string;
}

function Hero({ title, description }: HeroProperties) {
  return (
    <SectionBase id={SECTION_ID} background="bg-background">
      <SectionHeader
        subtitle="SERVICE AREA"
        title={title}
        description={description}
      />
    </SectionBase>
  );
}

export default Hero;
